import React, {Component} from "react";
import {RouteComponentProps} from "react-router-dom";
import {LandingContainer} from "../landing-container/landing-container";
import Button from "@material-ui/core/Button";
import {NewsCard} from "../landing-news/news-card";
import labraHr from "../img/LABRA_HR.png";
import labraAi from "../img/LABRA_Ai.png"
import labraTracker from "../img/labra_tracker.png";
import ciblock from "../img/CiBlock_logo.png";
import steelunicorn from "../img/SteelUnicorn_logo.png";
import evan from "../img/EVAN_logo_square.png";
import calculator from "../img/Calc_1.png";
import "./../landing-news/landing-news.css";

interface ProductsProps extends RouteComponentProps {}

export class Products extends Component<ProductsProps> {
    render() {
        return (
            <LandingContainer>
                <div id="news-container" className="landing-section">
                    <div id="news-content" className="landing-section-content">
                        <div className="news-content-cards" id="products-cards-top">
                            <NewsCard
                                picture={labraHr}
                                header={<h3>LABRA HR</h3>}
                                text={
                                    <p>
                                        <b>Система управления эффективностью ручного труда</b> на основе данных с камер наблюдения.
                                        Автоматический анализ производительности, KPI сотрудников и нормирование труда.
                                        Снижайте затраты на персонал на <b>15%</b> и повышайте эффективность на <b>75%</b>.
                                    </p>
                                }
                                hrefText={'Перейти'}
                                href='/#/hr'
                            />
                            <NewsCard
                                picture={labraAi}
                                header={<h3>LABRA AI</h3>}
                                text={
                                    <p>
                                        <b>Платформа автоматического нормирования и хронометража операций</b> с компьютерным зрением.
                                        Обучайте модели на ваших видео, анализируйте производительность в real-time
                                        и получайте точные данные для оптимизации труда. Точность аналитики — <b>95%</b>.
                                    </p>
                                }
                                hrefText={'Перейти'}
                                href='/#/ai'
                            />
                            <NewsCard
                                picture={calculator}
                                header={<h3>Калькулятор производительности труда</h3>}
                                text={
                                    <p>
                                        Рассчитайте <b>потенциальное повышение производительности труда</b> и необходимое
                                        количество замеров для нормирования. Получите оценку эффективности и ROI от внедрения
                                        автоматизации аналитики на вашем производстве.
                                    </p>
                                }
                                hrefText={'Перейти'}
                                href='/#/calculator'
                            />
                            <NewsCard
                                picture={evan}
                                header={<h3>EVAN</h3>}
                                text={
                                    <p>
                                        <b>Event Analytics для выставок, музеев и торговых площадок</b>. Тепловые карты зон,
                                        tracking пути посетителей, метрики по стендам и анализ популярности маршрутов в
                                        реальном времени. Оптимизируйте расположение экспозиций на основе данных.
                                    </p>
                                }
                                hrefText={'Перейти'}
                                href='/#/evan'
                            />
                        </div>
                    </div>
                </div>
                <div id="news-container" className="landing-section">
                    <div id="news-content" className="landing-section-content">
                        <div className="news-content-cards" id="products-cards-top">
                            <NewsCard
                                picture={labraTracker}
                                header={<h3>LABRA Tracker</h3>}
                                text={
                                    <p>
                                        <b>Инструмент для управления проектами и задачами</b>. Все задачи и бэклог на одном экране,
                                        экономя до <b>80%</b> времени на планирование. Интуитивный интерфейс для максимальной
                                        эффективности команды. Попробуйте прямо сейчас!
                                    </p>
                                }
                                hrefText={'Перейти'}
                                href='https://tracker.labrahub.ru'
                            />
                            <NewsCard
                                picture={steelunicorn}
                                header={<h3>SteelUnicorn</h3>}
                                text={
                                    <p>
                                        <b>Плагин для автоматизации проектирования опалубки в AutoCAD</b>. Работает на <b>30% быстрее</b>
                                        даже на крупных чертежах с множеством слоев. Быстрая адаптация разрезов и маркировки
                                        при изменениях — экономьте время проектировщиков.
                                    </p>
                                }
                                hrefText={'Перейти'}
                                href='https://www.steelunicorn.ru'
                            />
                            <NewsCard
                                picture={ciblock}
                                header={<h3>CiBlock</h3>}
                                text={
                                    <p>
                                        <b>GIS-платформа для градостроительного проектирования</b>. Планирование дорожной сети,
                                        расчет плотности застройки, AI-оптимизация инфраструктуры и выгрузка в AutoCAD.
                                        Сокращайте затраты на проектирование микрорайонов с алгоритмами оптимизации.
                                    </p>
                                }
                                hrefText={'Подробнее'}
                                href='https://www.labrahub.ru/#/ciblock'
                            />
                        </div>
                    </div>
                </div>
            </LandingContainer>
        )
    };
}
